module.exports = __webpack_public_path__ + "static/media/ne.b8a0e9ae.svg";